import { useEffect } from 'react';

const useUnsavedChanges = (checkUnsavedChanges) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (checkUnsavedChanges()) {
        event.preventDefault();
        return '';
      }
      return undefined;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [checkUnsavedChanges]);
};

export default useUnsavedChanges;
